import { FC, useEffect, useState } from "react";
import AdminPage from "../AdminPage";
import { useParams } from "react-router-dom";
import { apiClient } from "../../utils/apiClient";
import { InternalEmailThreadComponent } from "../../internal/Email/InternalEmailThreadComponent";
import { EmailGetMessageMetadataResponse } from "@services/documents/email/types";

export type Props = {
  useMessageId?: boolean;
};

export const InternalEmailThreadPage: FC<Props> = ({
  useMessageId,
}): JSX.Element => {
  const { id } = useParams();
  const [threadId, setThreadId] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!useMessageId || !id) {
      setThreadId(id || null);
      return;
    }

    const fetchMetadata = async () => {
      setLoading(true);
      try {
        const res = await apiClient.get<EmailGetMessageMetadataResponse>(
          `/documents/email/message_metadata/${id}`,
          {}
        );
        if (res.threadId) {
          setThreadId(res.threadId);
        } else {
          setError("No thread id in message metadata");
        }
      } catch (err) {
        setError("Failed to fetch message metadata");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMetadata();
  }, [id, useMessageId]);

  if (!id) return <AdminPage>no thread id</AdminPage>;
  if (loading) return <AdminPage>Loading...</AdminPage>;
  if (error) return <AdminPage>{error}</AdminPage>;
  if (!threadId) return <AdminPage>No thread found</AdminPage>;

  return (
    <AdminPage>
      <InternalEmailThreadComponent
        threadId={threadId}
        selectedMessageId={useMessageId ? id : undefined}
      />
    </AdminPage>
  );
};
